import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import './home.css';
import Herosection from '../components/Herosection';
import Footer from '../components/Footer';
import IntroSection from './sections/IntroSection';
import ProductsSection from './sections/ProductsSection';
import DeliverySection from './sections/DeliverySection';
import ContactSection from './sections/ContactSection';
import translations from './translations';

const sectionIds = ['hero', 'intro', 'products', 'delivery', 'contact'];
const navItems = [
  { id: 'hero', key: 'hero' },
  { id: 'intro', key: 'intro' },
  { id: 'products', key: 'products' },
  { id: 'delivery', key: 'delivery' },
  { id: 'contact', key: 'contact' },
];

const Home = () => {
  const [lang, setLang] = useState('el');
  const [navOpen, setNavOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  useEffect(() => {
    const browserLang = (navigator.language || 'el').toLowerCase();
    setLang(browserLang.startsWith('el') ? 'el' : 'en');
  }, []);

  useEffect(() => {
    const sections = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (!sections.length) {
      return undefined;
    }

    let ticking = false;

    const updateActiveSection = () => {
      const headerOffset = window.innerWidth <= 860 ? 140 : 110;
      const scrollPosition = window.scrollY + headerOffset;

      let nextActiveSection = sections[0].id;

      sections.forEach((section) => {
        if (scrollPosition >= section.offsetTop) {
          nextActiveSection = section.id;
        }
      });

      setActiveSection(nextActiveSection);
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateActiveSection);
        ticking = true;
      }
    };

    updateActiveSection();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateActiveSection);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', updateActiveSection);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = navOpen ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [navOpen]);

  const t = translations[lang];
  const handleNavLinkClick = (sectionId) => {
    setActiveSection(sectionId);
    setNavOpen(false);
  };

  return (
    <>
      <MetaTags>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>{t.meta.title}</title>
        <link rel="icon" href="/favicon.ico" />
        <link rel="shortcut icon" href="/favicon.ico" />
        <link rel="canonical" href="https://biokaliergia.gr" />
        <link rel="apple-touch-icon" href="/biokaliergia.png" />
        <meta
          name="description"
          content={t.meta.description}
        />
        <meta
          name="keywords"
          content={t.meta.keywords}
        />
      </MetaTags>

      <main className="oregano-page">
        <header className="oregano-nav">
          <div className="oregano-nav__brand">{t.brand}</div>
          <nav className="oregano-nav__links">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={activeSection === item.id ? 'is-active' : ''}
                onClick={() => handleNavLinkClick(item.id)}
              >
                {t.nav[item.key]}
              </a>
            ))}
          </nav>
          <div className="oregano-nav__actions">
            <button
              type="button"
              className="oregano-nav__toggle"
              aria-label="Toggle navigation"
              aria-expanded={navOpen}
              onClick={() => setNavOpen(!navOpen)}
            >
              <span />
              <span />
              <span />
            </button>
            <button
              type="button"
              className="oregano-nav__lang"
              onClick={() => setLang(lang === 'el' ? 'en' : 'el')}
              aria-label={t.toggleAria}
            >
              {t.toggle}
            </button>
          </div>
        </header>

        <div className={`oregano-sidenav ${navOpen ? 'is-open' : ''}`}>
          <button
            type="button"
            className="oregano-sidenav__close"
            aria-label="Close navigation"
            onClick={() => setNavOpen(false)}
          >
            ×
          </button>
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={activeSection === item.id ? 'is-active' : ''}
              onClick={() => handleNavLinkClick(item.id)}
            >
              {t.nav[item.key]}
            </a>
          ))}
        </div>
        {navOpen ? (
          <div
            className="oregano-sidenav__backdrop"
            role="presentation"
            onClick={() => setNavOpen(false)}
          />
        ) : null}

        <section id="hero">
          <Herosection t={t} />
        </section>

        <IntroSection t={t} />
        <ProductsSection t={t} />
        <DeliverySection t={t} />
        <ContactSection t={t} />

        <Footer />
      </main>
    </>
  );
};


export default Home;
